import { Row, Txt } from "@stenajs-webui/core";
import type { FC } from "react";

import { ApproveAlert } from "../../../../common-ui/ApproveAlert";
import { stopPropagation } from "../../../../common/eventHelpers";
import type { BasicBooking } from "../../../../common/graphql/fragments/gql/BasicBooking";
import {
  type ApprovalConfig,
  getApprovalInfo,
} from "../../../../common/utils/approvalInfo";
import {
  type GoodsApproval,
  GoodsApprovalType,
} from "../../../../common/utils/GoodsApproval";
import { resolveLoadingPreferenceApproved } from "../../../../common/utils/loadingPreferenceUtil";

const getLoadingPreferenceApprovalInfo = (
  booking: BasicBooking,
): ApprovalConfig | null => {
  const loadingPreferenceApproval: GoodsApproval = {
    status: resolveLoadingPreferenceApproved(
      booking.loadingPreference,
      booking.loadingPreferenceStatusCode,
    ),
    type: GoodsApprovalType.LoadingPreference,
  };
  return getApprovalInfo(loadingPreferenceApproval);
};

export const LoadingPreferenceCell: FC<{
  booking: BasicBooking;
}> = ({ booking }) => {
  const approvalInfo = getLoadingPreferenceApprovalInfo(booking);

  return (
    <Row gap>
      <Txt whiteSpace={"nowrap"}>{booking.loadingPreference?.label}</Txt>
      {approvalInfo && (
        <Row onClick={stopPropagation}>
          <ApproveAlert config={approvalInfo} />
        </Row>
      )}
    </Row>
  );
};
